// extracted by mini-css-extract-plugin
module.exports = {"pseudo-elements-screenshot":"FontAwesomeAdminView_pseudo-elements-screenshot__28Q3T","tab-header":"FontAwesomeAdminView_tab-header__2ZrhV"};